import axiosClient from './axiosClient';

export const QuestionBank = {
  getQuestionList: (payload) => {
    const url = `api/question/list`;

    return axiosClient.post(url, payload);
  },
  getQuestionsList: (payload) => {
    return axiosClient.post('api/question/getQuestionId', payload);
  },
  questionStatus: (data) => {
    return axiosClient.post('api/question/questionStatus', data);
  },
  createQuestion: (data) => {
    return axiosClient.post('api/question/create', data);
  },

  updateQuestion: (data) => {
    return axiosClient.post('api/question/update', data);
  },

  deleteQuestion: (ids) => {
    return axiosClient.post('api/question/delete', { ids });
  },

  getQuestionDetails: (id) => {
    return axiosClient.post('api/question/update', { id });
  },
  getCatogoryQuestionList: (payload) => {
    console.log(payload);

    return axiosClient.post('api/question/categoryQuestion', payload);
  },

  getQuestionListByUser: (user_id) => {
    return axiosClient.post('api/survey/list', { user_id });
  },

  getQuestionsByCategory: (categoryId, limit = 50, offset = 0) => {
    const url = `/api/question/categoryQuestion`;
    if (!categoryId || categoryId === 'all') {
      return axiosClient.post(url, { limit, offset });
    }
    return axiosClient.post(url, { category_id: categoryId, limit, offset });
  },

  getDashboard: (payload) => {
    return axiosClient.post('/survey/dashboard', payload);
  },
};
